import { domainApi } from '../../../store/apimiddleware';
// Define a service using a base URL and expected endpoints
export const domainApiSlice = domainApi
    .enhanceEndpoints({
    addTagTypes: ['Domain APIs'],
})
    .injectEndpoints({
    endpoints: (build) => ({
        status: build.query({
            query: (data) => ({
                url: `${data}`,
                method: 'get',
            }),
        }),
    }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useStatusQuery } = domainApiSlice;
